import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ComplaintForm from './components/ComplaintForm';
import ThankYouPage from './components/ThankYouPage';
import Dashboard from './components/Dashboard';
import Header from './components/Header';

function AppContent() {
  const location = useLocation();
  const showHeader = location.pathname !== '/dashboard';

  return (
    <div className="min-h-screen">
      {showHeader && <Header />}
      <main className={showHeader ? "container mx-auto px-4 py-6" : ""}>
        <Routes>
          <Route path="/" element={<ComplaintForm />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </main>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            borderRadius: '12px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
          },
          success: {
            duration: 3000,
            style: {
              background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            },
          },
          error: {
            style: {
              background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
            },
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;